(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kbay-stock-update"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('KbayStockUpdate');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const key = 'kbay_stock_arrival_2026_10';
    let seen = false;
    try { seen = sessionStorage.getItem(key) === 'seen'; } catch {}
    if (!seen) seen = document.cookie.split('; ').some(part => part === key + '=seen');
    if (seen) return;
    const previousFocus = document.activeElement;
    const previousOverflow = document.documentElement.style.overflow;
    dialog.querySelectorAll('[data-stock-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      const target = previousFocus && previousFocus !== document.body && previousFocus.isConnected ? previousFocus : document.getElementById('MainContent');
      target?.focus({ preventScroll: true });
    });
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    try { sessionStorage.setItem(key, 'seen'); } catch {}
    document.cookie = key + '=seen; Path=/; SameSite=Lax; Secure';
  })();
  } catch(e) { console.error(e); }
})();

})();
